import cookies from 'vue-cookies'
const state = {
    user_id : 0,
    token: cookies.get('token') || null,
    isAuthenticated: cookies.get('token') ? true : false,
    isAdmin: false,
    referentialDisplay:true,
    userInfo:[],
    emailAnswer:[],
    emailState:[],
    respStatus: 0,
    loading:false,
    tempToken:[],
}

export default state